import {PopupForm, DividerAdd} from "@tracabois/components"
import {RealizationActorCreateForm} from "./RealizationActorCreateForm"
import {useTranslation} from "react-i18next"
import {useMemo, useState} from "react"
import {RealizationActorAssignForm} from "./RealizationActorAssignForm"
import Box from "@mui/material/Box"
import {RealizationAssignActorCommand, RealizationId} from "../../../model/realizationModel"

const useLabels = () => {
  const {t} = useTranslation()
  return useMemo(() => ({
    create: t("realization.actor.create.title", "Créer un acteur"),
    select: t("realization.actor.select.title", "Sélectionner un acteur"),
    title: t("realization.actor.assign.title", "Ajouter un acteur"),
  }), [])
}

export interface RealizationActorAddFormPopupProps {
  onSubmit: (item: RealizationAssignActorCommand) => Promise<boolean> | boolean
  open: boolean
  onClose: () => void
  realizationId: RealizationId
}

export const RealizationActorAddFormPopup = (props: RealizationActorAddFormPopupProps) => {
  const {onSubmit, open, onClose, realizationId} = props
  const labels = useLabels()
  const [showCreation, setShowCreation] = useState<boolean>(false)
  return (
    <PopupForm open={open} onClose={onClose} title={labels.title}>
      <Box minWidth={500}>
      {!showCreation && (<>
        <DividerAdd loading={false} readOnly={false} onClick={() => setShowCreation(true)} icon={<>{labels.create}</>} />
        <RealizationActorAssignForm
          realizationId={realizationId}
          onCancel={() => {
            onClose()
            return true;
          }}
          onSubmit={onSubmit}
        />
      </>)}

      {showCreation && (<>
        <DividerAdd loading={false} readOnly={false} onClick={() => setShowCreation(false)} icon={<>{labels.select}</>}/>
        <RealizationActorCreateForm
          realizationId={realizationId}
          onCancel={() => {
            onClose()
            return true;
          }}
          onSubmit={onSubmit}/>
      </>)}
      </Box>
    </PopupForm>
  )
}
